function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Input, CurrencyInput } from "../../../helperComponents";
import { CurrencyTypes } from "../../../utils/data";
import { formatValue } from "../../../utils/currency";
import { constructionMaterialsOptions } from "../data";
import RegionSelector from "../../regions/RegionSelector";
import ComunaSelector from "../../comunas/ComunaSelector";

var HomeFire = function HomeFire(props) {
  var _itemAsegurado$additi, _itemAsegurado$additi2;

  var itemAsegurado = props.itemAsegurado,
      _onChange = props.onChange,
      listRegions = props.listRegions,
      listCommunes = props.listCommunes,
      index = props.index;
  var materialSelectedOption = constructionMaterialsOptions.find(function (construction_material) {
    return (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.construction_material) === construction_material.value;
  });
  var additionalCoverages = (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.additional_coverages) || [];

  var onChangeAdditionalCoverages = function onChangeAdditionalCoverages(event) {
    var newAdditionalCoverages = event.target.checked ? [].concat(_toConsumableArray(additionalCoverages), [event.target.value]) : additionalCoverages.filter(function (ac) {
      return ac !== event.target.value;
    });
    _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
      additional_coverages: newAdditionalCoverages
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody cntRamo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Regi\xF3n Riesgo"), /*#__PURE__*/React.createElement(RegionSelector, {
    regions: listRegions,
    regionId: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.risk_region_id,
    onChange: function onChange(region_id) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        risk_region_id: region_id
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Comuna Riesgo"), /*#__PURE__*/React.createElement(ComunaSelector, {
    comunas: listCommunes,
    regionId: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.risk_region_id,
    comunaId: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.risk_commune_id,
    onChange: function onChange(comuna_id) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        risk_commune_id: comuna_id
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Direcci\xF3n Riesgo"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    className: "addMarginBottom",
    placeholder: "Escriba Dirección...",
    value: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.risk_address,
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        risk_address: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de Ubicaci\xF3n"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_location_type_urbano"),
    id: "".concat(index, "_location_type_urbano"),
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.location_type) === "urbano",
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        location_type: "urbano"
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Urbano"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_location_type_rural"),
    id: "".concat(index, "_location_type_rural"),
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.location_type) === "rural",
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        location_type: "rural"
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Rural")))), /*#__PURE__*/React.createElement("div", {
    className: "row col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Uso"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_use_time_permanente"),
    id: "".concat(index, "_use_time_permanente"),
    value: "permanente",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.use_time) === "permanente",
    onChange: function onChange(e) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        use_time: e.currentTarget.value
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Permanente"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_use_time_vacacional"),
    id: "".concat(index, "_use_time_vacacional"),
    value: "vacacional",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.use_time) === "vacacional",
    onChange: function onChange(e) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        use_time: e.currentTarget.value
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Vacacional"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de Vivienda"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_housing_type_casa"),
    id: "".concat(index, "_housing_type_casa"),
    value: "casa",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.housing_type) === "casa",
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        housing_type: "casa"
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Casa"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_housing_type_departamento"),
    id: "".concat(index, "_housing_type_departamento"),
    value: "departamento",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.housing_type) === "departamento",
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        housing_type: "departamento"
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Departamento"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Material de Construcci\xF3n"), /*#__PURE__*/React.createElement(Select, {
    className: "addMarginBottom",
    options: constructionMaterialsOptions,
    value: materialSelectedOption,
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione Material...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        construction_material: item === null || item === void 0 ? void 0 : item.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "A\xF1o de Construcci\xF3n"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control addMarginBottom",
    selected: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.construction_year) && new Date(itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.construction_year, 0),
    onChange: function onChange(date) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        construction_year: date.getFullYear()
      }));
    },
    showYearPicker: true,
    dateFormat: "yyyy"
  }))), (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.housing_type) === "departamento" && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 cntDepartamentoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xB0 Bodega"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    placeholder: "Escriba número...",
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.warehouse_number) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        warehouse_number: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xB0 Estacionamiento"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    placeholder: "Escriba número...",
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.parking_number) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        parking_number: event.target.value
      }));
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Monto Asegurado Edificio"), /*#__PURE__*/React.createElement(CurrencyInput, {
    currency: CurrencyTypes.UF,
    className: "form-control",
    defaultValue: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.building_insured_amount,
    onValueChange: function onValueChange(value) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        building_insured_amount: formatValue(value, 3)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Monto Asegurado Contenido"), /*#__PURE__*/React.createElement(CurrencyInput, {
    currency: CurrencyTypes.UF,
    className: "form-control",
    defaultValue: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.content_insured_amount,
    onValueChange: function onValueChange(value) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        content_insured_amount: formatValue(value, 3)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Coberturas Adicionales"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    id: "inlineCheckbox1",
    checked: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : (_itemAsegurado$additi = itemAsegurado.additional_coverages) === null || _itemAsegurado$additi === void 0 ? void 0 : _itemAsegurado$additi.includes("sismo"),
    value: "sismo",
    onChange: onChangeAdditionalCoverages
  }), " ", /*#__PURE__*/React.createElement("label", {
    className: "form-check-label"
  }, "Sismo"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    id: "inlineCheckbox2",
    checked: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : (_itemAsegurado$additi2 = itemAsegurado.additional_coverages) === null || _itemAsegurado$additi2 === void 0 ? void 0 : _itemAsegurado$additi2.includes("robo"),
    value: "robo",
    onChange: onChangeAdditionalCoverages
  }), " ", /*#__PURE__*/React.createElement("label", {
    className: "form-check-label"
  }, "Robo")))));
};

export default HomeFire;